// components/project-details/CompletionModal.js
import React from 'react';
import styles from './ProjectDetails.module.css';

const CompletionModal = ({ isOpen, onClose, onConfirm, projectName }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modal} onClick={onClose}>
      <div 
        className={styles.modalContent} 
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '500px' }}
      >
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>Complete Project</h3>
          <button 
            onClick={onClose} 
            className={styles.modalCloseButton}
          >
            <svg 
              style={{ width: '1.5rem', height: '1.5rem' }} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div style={{ padding: 'var(--spacing-l)' }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            marginBottom: 'var(--spacing-m)' 
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: 'var(--radius-pill)',
              background: 'var(--Amber-100)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <svg 
                style={{ width: '24px', height: '24px', color: 'var(--Amber-600)' }} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          </div>

          <h4 style={{ 
            fontSize: 'var(--font-size-subtitle2)',
            fontWeight: 'var(--font-weight-subtitle2)',
            color: 'var(--Text-Primary)',
            textAlign: 'center',
            marginBottom: 'var(--spacing-xs)'
          }}>
            Are you sure you want to complete this project?
          </h4>

          {projectName && (
            <p style={{
              fontSize: 'var(--font-size-body4)',
              color: 'var(--Text-Secondary)',
              textAlign: 'center',
              marginBottom: 'var(--spacing-m)'
            }}>
              Project: <strong>{projectName}</strong>
            </p>
          )}

          <div style={{
            background: 'var(--Surface-Secondary)',
            borderRadius: 'var(--radius-s)',
            padding: 'var(--spacing-m)',
            marginBottom: 'var(--spacing-l)'
          }}>
            <p style={{ 
              fontSize: 'var(--font-size-body4)',
              color: 'var(--Text-Primary)',
              marginBottom: 'var(--spacing-s)'
            }}>
              Before marking as complete, please confirm:
            </p>
            <ul style={{ 
              margin: 0,
              paddingLeft: 'var(--spacing-l)',
              fontSize: 'var(--font-size-body4)',
              color: 'var(--Text-Secondary)',
              display: 'flex',
              flexDirection: 'column',
              gap: 'var(--spacing-xs)'
            }}>
              <li>The customer has received their ring</li>
              <li>All payments have been collected</li>
              <li>The project is finished and delivered</li>
            </ul>
          </div>

          <div style={{ 
            display: 'flex', 
            gap: 'var(--spacing-s)', 
            justifyContent: 'flex-end' 
          }}>
            <button
              onClick={onClose}
              style={{
                padding: 'var(--spacing-s) var(--spacing-l)',
                background: 'var(--Grey-100)',
                color: 'var(--Text-Primary)',
                border: 'none',
                borderRadius: 'var(--radius-s)',
                fontSize: 'var(--font-size-body3)',
                fontWeight: 'var(--font-weight-medium)',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => e.target.style.background = 'var(--Grey-200)'}
              onMouseOut={(e) => e.target.style.background = 'var(--Grey-100)'}
            >
              Not Yet
            </button>
            <button
              onClick={onConfirm}
              style={{
                padding: 'var(--spacing-s) var(--spacing-l)',
                background: 'var(--brand-gradient-1)',
                color: 'white',
                border: 'none',
                borderRadius: 'var(--radius-s)',
                fontSize: 'var(--font-size-body3)',
                fontWeight: 'var(--font-weight-medium)',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
              onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
            >
              Yes, Complete Project
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletionModal;